module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-LightItalic-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-LightItalic-webfont.eot
// module id = 349
// module chunks = 0